module.exports = __webpack_public_path__ + "img/celvexiangqing.67957528.png";